<template>
    <div class="ReturnOrderDetail" style="min-width: 1200px !important; min-height: 95vh;">
        <q-card style="min-width: 1200px !important; min-height: 95vh;">
            <q-card-section>
                <div class="row">
                    <div class="d-flex col-12 q-pa-md pt-0"
                         style="justify-content: space-between; align-items: center ">
                        <div><h4 style="font-size: 22px; font-weight: 300;">Return Order Details</h4></div>
                        <div class="drawerButtons" style="margin-top: -10px;">
                            <q-btn @click="closeDialog" flat icon="close" round size="small"></q-btn>
                        </div>
                    </div>
                    <div class="col-4 q-pa-md" style="border-right: 1px solid lightgray">
                        <ul style="list-style: none">
                            <li class="pb-3" style="border-bottom: 1px solid #e0e0e0">
                                <span class="bankLabel d-block">Order ID</span>
                                <h4 style="font-size: 24px; font-weight: 400">
                                    {{returnOrderDetail.orderNum?returnOrderDetail.orderNum:'-'}}</h4>
                            </li>
                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                <span class="bankLabel d-block">Partner Type</span>
                                <span>{{returnOrderDetail.ToOrganization?returnOrderDetail.ToOrganization.PartnerType.prefix:'-'}}</span>
                            </li>
                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                <span class="bankLabel d-block">Order From</span>
                                <span>{{returnOrderDetail.FromOrganization?returnOrderDetail.FromOrganization.name:'-'}}</span>
                            </li>
                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                <span class="bankLabel d-block">Order To</span>
                                <span>{{returnOrderDetail.ToOrganization?returnOrderDetail.ToOrganization.name:'-'}}</span>
                            </li>
                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                <span class="bankLabel d-block">Order Date</span>
                                <span>{{returnOrderDetail.date?dateFilter(returnOrderDetail.date):'-'}}</span>
                            </li>
                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                <span class="bankLabel d-block">Created on</span>
                                <span>{{returnOrderDetail.createdOn?dateTimeFilter(returnOrderDetail.createdOn):'-'}}</span>
                            </li>
                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                <span class="bankLabel d-block">Invoice No</span>
                                <span>{{returnOrderDetail.invoiceNumber?returnOrderDetail.invoiceNumber:'-'}}</span>
                            </li>
                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                <span class="bankLabel d-block">Invoice Date</span>
                                <span>{{returnOrderDetail.invoiceDate?dateFilter(returnOrderDetail.invoiceDate):'-'}}</span>
                            </li>
                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                <span class="bankLabel d-block">Invoice Note</span>
                                <span>{{returnOrderDetail.invoiceNote?returnOrderDetail.invoiceNote:'-'}}</span>
                            </li>
                        </ul>
                    </div>

                    <div class="col-8 q-pa-md" style="height: 80vh; overflow-y: auto">
                        <h6 style="margin-top: -18px;margin-bottom: 10px;">
                            Total Items : {{returnOrderDetail.OrderItems.length}}</h6>
                        <q-list bordered class="rounded-borders">
                            <template v-for="(product, index) in returnOrderDetail.productArr">
                                <q-expansion-item>
                                    <template slot="header">
                                        <q-item-section> {{product.productName}}</q-item-section>
                                        <q-item-section side>{{product.batchArr.length}}</q-item-section>
                                    </template>
                                    <q-card>
                                        <q-card-section>
                                            <q-list bordered padding>
                                                <q-item :key="i" tag="label"
                                                        v-for="(batch, i) in product.batchArr">
                                                    <q-item-section>
                                                        <q-item-label>{{batch.batch}}</q-item-label>
                                                        <q-item-label caption> {{product.productLineCode}}
                                                        </q-item-label>
                                                    </q-item-section>
                                                </q-item>
                                            </q-list>
                                        </q-card-section>
                                    </q-card>
                                </q-expansion-item>
                            </template>
                        </q-list>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
  import { GET_RETURN_ORDER_DETAIL } from '../../graphql/queries/ReturnOrder'
  import Constants from '../../Constants/Constant'

  export default {
    name: 'ReturnOrderDetail',
    props: ['orderId'],
    data () {
      return {
        returnOrderDetail: {},
      }
    },
    apollo: {
      ReturnOrderDetail: {
        query: GET_RETURN_ORDER_DETAIL,
        fetchPolicy: 'network-only',
        skip () {return !this.orderId},
        variables () {
          return { orderId: this.orderId }
        },
        result ({ data, loading }) {
          if (!loading) {
            this.returnOrderDetail = data.ReturnOrderDetail.length ? data.ReturnOrderDetail[0] : []
            this.groupOrderItemsByProductId()
          }
        },
      },
    },
    methods: {
      groupOrderItemsByProductId () {
        let self = this
        self.returnOrderDetail['productArr'] = []
        self.returnOrderDetail.OrderItems.forEach(function (current) {
          if (!Constants.containsObject({ productId: current.Batch.productId }, self.returnOrderDetail.productArr)) {
            self.returnOrderDetail.productArr.push({ productId: current.Batch.productId })
          }
        })
        self.returnOrderDetail.productArr.forEach(function (product) {
          product.batchArr = []
          self.returnOrderDetail.OrderItems.forEach(function (current) {
            if (product.productId == current.Batch.productId) {
              current.Batch.orderItemId = current.orderItemId
              current.Batch.orderItemStatus = current.orderItemStatus
              product.batchArr.push(current.Batch)
              if (current.Product) {
                product.productName = current.Product.name
                product.productLineName = current.Product.ProductLine.name
                product.OemName = current.Product.OEM.name
                product.productLineCode = current.Product.productLineCode
              }
            }
          })
        })
      },
      closeDialog () {
        this.$emit('closeDialog')
      },
    },
  }
</script>

<style scoped>
    .card {
        text-align: center;
        width: 100%;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: bottom;
        border-radius: 4px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
        position: relative;
    }
</style>
